// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2xuIc","header":"ClearentDisclaimer_header__2579N","inner":"ClearentDisclaimer_inner__1QF5M"};